import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../../environment/BackendService";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";

const useGpiProductId = (
  setScreenType,
  selectParams,
  hideModal,
  lookupType,
  selectMode,
  onSelect,
  screen_title,
  screenNumber, 
  multiSelect
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [paramsData, setParamsData] = useState({
    pidProductId: "",
    prdDescriptionAbbrev: "",
    pidProductStatus: "A",
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { GPI_SCREEN } = ROUTE_PATHS;

  const formFields = [
    {
      fieldLabel: "PID Product ID",
      name: "pidProductId",
      label: "Product ID",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 20,
    },
    {
      fieldLabel: "PRD Description Abbrev",
      name: "prdDescriptionAbbrev",
      label: "Label Name",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 20,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "pidProductStatus",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
    {
      button_label: "Search by GPI Name/ID",
      button_handeler: () => {
        //navigateToPage(GPI_SCREEN);
        setScreenType("gpiName");
      },
      button_key: "F16",
    },
  ];

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        hideModal();
      },
      button_key: "F12",
    },
  ];

  const getDescription = async (params) => {
    try {
      const { responseData = [] } = await axios_helper_no_header("GET", "api/rcgpip", {}, params);
      return responseData;
    } catch (e) {
      console.error(e);
      return [];
    }
  };

  const getAllDescriptions = async (selectedRecords) => {
    const results = await Promise.all(
      selectedRecords.map(async (row) => {
        const params = { gpiId: row.gpiIdNumber };
        const [responseData = { ...params }] = await getDescription(params);

        return selectParams.reduce((acc, key) => {
          if (responseData.hasOwnProperty(key.target)) {
            acc[key.source] = responseData[key.target];
          }
          return acc;
        }, {});
      })
    );

    return results;
  };

  const menuOptions = [
     {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: async () => {
        try {
          const selectedRecords = selectedRows.length ? selectedRows : [rowData];
          const selectedData = await getAllDescriptions(selectedRecords);

          if (lookupType !== "external") {
            onSelect(multiSelect ? selectedData : selectedData[0]);
          } else {
            const message = {
              type: "responseData",
              data: multiSelect ? selectedData : selectedData[0],
              multiSelect: multiSelect,
            };
            window.parent.postMessage(message, "*");
          }
        } catch (error) {
          console.error(error);
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: async () => {
        try {
          const params = { gpiId: rowData["gpiIdNumber"] };
          const [responseData = {}] = await getDescription(params);
          const pidProductIdWithoutHyphens = rowData["pidProductId"].replace(/-/g, '');
          const message = {
            message: "navigate-to-presto",
            programCode: "RCPRD0051",
            parameters: {
              prdKey: rowData['prdkey'],
              ptyProductTypeCode: rowData['ptyProductTypeCode'],
              pidProductId:pidProductIdWithoutHyphens,
              commandKeyUsed: 'F17'
            },
          };
          window.top?.postMessage(message, "*");
        } catch (error) {
          console.error(error);
        }
      },
    },
  ];

  const columnDef = [
    { header: "Product ID", field: "pidProductId" },
    { header: "Product Type", field: "ptyType" },
    { header: "Label Name", field: "prdDescriptionAbbrev" },
    { header: "GPI", field: "gpiIdNumber" },
    { header: "Manufacturer", field: "mfgManufacturer" },
    { header: "Repackage", field: "prdRepackageCode" },
    { header: "Status", field: "pidProductStatus" },
  ];

  const parmKey = "prdkey";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcpidp`,
        null,
        { page: page, size: rows, ...paramsData }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { prcPriceScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/priceschedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData, screenNumber });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcpidp/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setParamsData(paramData?.paramsData)
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    leftButtons,
  };
};

export default useGpiProductId;
